export const MAX_SIZE_COMPARE_BUCKET = 3;

export const ACTIONS = {
    ADD_MODEL_TO_COMPARE_BUCKET : 'ADD_MODEL_TO_COMPARE_BUCKET',
    REMOVE_MODEL_FROM_COMPARE_BUCKET : 'REMOVE_MODEL_FROM_COMPARE_BUCKET'
};



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/constants/index.js